var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentColor",
    d: "M5.363 1.475A4.363 4.363 0 1 1 1 5.84a4.363 4.363 0 0 1 4.363-4.364Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentColor",
    d: "M9.564 14.524a6.234 6.234 0 0 0-4.2-1.778 6.233 6.233 0 0 0-4.2 1.778"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentColor",
    d: "M12.169 9.017a2.044 2.044 0 1 1-2.044 2.043 2.044 2.044 0 0 1 2.044-2.043Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentColor",
    d: "M15.001 14.524a4.66 4.66 0 0 0-3.137-1.297 4.445 4.445 0 0 0-2.524.838"
  })));
};
export default SvgUser;